import React, { Component } from 'react';
import './ChartList.css';
import BarChart from '../charts/barchart/BarChart';
import LineChart from '../charts/lineChart/LineChart';
import PieChart from '../charts/pieChart/PieChart';

class ChartList extends Component {
    render() {
        return (
            <div>
                <div className="container">
                    <main className="grid">
                        <BarChart />
                        <LineChart />
                        <PieChart />
                        <BarChart />
                        <BarChart />
                        <BarChart />
                        <BarChart />
                    </main>
                </div>
            </div>
        );
    }
}

export default ChartList;
